<template>
  <div class="ml-16 flex gap-16">
    <RevIllustration alt="" :height="24" :src="iconSrc" :width="24" />

    <div class="flex flex-col items-start">
      <p class="body-1">{{ title }}</p>
      <p class="text-static-default-low caption">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  title: string
  subtitle: string
  iconSrc: string
}>()
</script>
